import { authSlice, whitelist as authWhitelist } from '@shared-core/features/auth/slice'
import { backendSlice, whitelist as backendWhitelist } from '@shared-core/features/backend/slice'
import { configSlice, whitelist as configWhitelist } from '@shared-core/features/config/slice'
import { envSlice, whitelist as envWhitelist } from '@shared-core/features/env/slice'
import { notificationsSlice, whitelist as notificationsWhitelist } from '@shared-core/features/notifications/slice'
import { settingsSlice, whitelist as settingsWhitelist } from '@shared-core/features/settings/slice'

export const sharedCoreWhitelist = {
  [authSlice.name]: authWhitelist,
  [backendSlice.name]: backendWhitelist,
  [configSlice.name]: configWhitelist,
  [settingsSlice.name]: settingsWhitelist,
  [envSlice.name]: envWhitelist,
  [notificationsSlice.name]: notificationsWhitelist,
}
